import React from 'react';

interface CptRow {
  baseRate?: number;
}

/**
 * Rate template with currency formatting
 */
export const RateTemplate: React.FC<{ rate: number | null | undefined }> = ({ rate }) => {
  const value = rate ?? 0;
  try {
    return <span>${value.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>;
  } catch {
    return <span>${parseFloat(value.toString() || '0').toFixed(2)}</span>;
  }
};

// Template function for grid column
export const rateTemplate = (props: CptRow) => <RateTemplate rate={props.baseRate} />;

export default RateTemplate;
